<div class="field-container">
  @if (props['label']) {
  <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
  <label class="field-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }

  @if (props['description']) {
  <p class="field-description">{{ props['description'] }}</p>
  }

  <div class="radio-group" [class.flex-responsive]="props['columns']" [class.col-2]="props['columns'] === 2"
    [class.col-3]="props['columns'] === 3" [class.col-4]="props['columns'] === 4">
    @for (option of radioOptions; track option.value) {
    <label class="radio-item">
      <input type="radio" [value]="option.value" [formControl]="formControl" [formlyAttributes]="field"
        class="radio-input" />
      <div class="option-content">
        <span class="radio-label">{{ option.label }}</span>
        @if (option.description) {
        <span class="option-description">{{ option.description }}</span>
        }
      </div>
    </label>
    }
  </div>

  @if (formControl.touched && formControl.errors) {
  <div class="field-error">
    @if (formControl.errors['required']) {
    <span>{{ 'field.validation.required' | translate }}</span>
    }
  </div>
  }
</div>